import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import 'material-components-web/dist/material-components-web.css'
import WebFont from 'webfontloader';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { makeMainRoutes } from './routes';

const routes = makeMainRoutes();


WebFont.load({
  google: {
    families: ['Roboto:300,500,700','Material Icons']
  }
});

ReactDOM.render(routes, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js